import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { GlassCard, Skeleton } from "@/v2/components/ui";
import { Bell, BellOff } from "lucide-react";

export default function Notifications() {
  const { data = [], isLoading } = useQuery({ queryKey: ["notifications"], queryFn: async () => (await api.get("/notifications")).data });
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-extrabold flex items-center gap-2"><Bell className="text-beige-ink" /> الإشعارات</h1>
      {isLoading ? <Skeleton className="h-40 w-full" /> : data.length === 0 ? (
        <GlassCard className="p-12 text-center text-ink-2"><BellOff size={40} className="mx-auto mb-3" /> لا توجد إشعارات حاليًا.</GlassCard>
      ) : (
        <div className="space-y-3">
          {data.map((n, i) => (
            <motion.div key={n.id} initial={{ opacity: 0, x: 16 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.03 }}>
              <GlassCard hover data-testid="v2-notification" className="p-5 flex items-start gap-4">
                <div className="w-11 h-11 rounded-2xl bg-ok/15 text-ok flex items-center justify-center shrink-0"><Bell size={20} /></div>
                <div><div className="font-bold">{n.title}</div><div className="text-sm text-ink-2 mt-0.5">{n.body}</div></div>
              </GlassCard>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
